// src/views/words-list/slice/selectors.ts
import { RootState } from '../../../redux/store';
import slice from './slice';

export const getIsLoadingWordsListData = (state: RootState) => state[slice.name].isLoading;
export const getWordsListData = (state: RootState) => state[slice.name].wordsList;
export const getIsLoadingError = (state: RootState) => state[slice.name].error;

export const getIsSaving = (state: RootState) => state[slice.name].isSaving;
export const getIsSavingError = (state: RootState) => state[slice.name].savingError;
